module.exports = __webpack_public_path__ + "img/circle_esg.e9fba7b3.png";